import type { Plugin, Context } from '@segment/analytics-next';
import hasImage from '../../utils/hasImage';

const enrichSegmentEvent = (ctx: Context) => {
  if (ctx.event?.properties?.product) {
    const { product, ...restProps } = ctx.event?.properties ?? {};

    const {
      title: productName,
      productCategory: vertical,
      market,
      uuid,
    } = product;

    const {
      skuUuid: skuUUID,
      productUuid: productUUID,
      lowestAsk,
    } = market || {};

    ctx.event.properties = {
      productName,
      vertical,
      skuUUID,
      lowestAsk,
      productUUID: productUUID || uuid,
      hasImage: Boolean(
        !!hasImage(product?.media?.imageUrl) ||
          hasImage(product?.media?.smallImageUrl),
      ),
      ...restProps,
    };
  }

  return ctx;
};

const enrichSegmentIdentify = (ctx: Context) => {
  //
  // customer username -> userName
  if (ctx.event?.traits?.username) {
    ctx.event.traits.userName = ctx.event.traits.username;
    delete ctx.event.traits.username;
  }

  return ctx;
};

/**
 *
 */
const modelEnrichmentPlugin: Plugin = {
  name: 'modelEnrichmentPlugin',
  type: 'enrichment',
  version: '1.0.0',

  isLoaded: () => true,
  load: () => Promise.resolve(),

  track: enrichSegmentEvent,
  identify: enrichSegmentIdentify,
  page: (ctx) => ctx,
  alias: (ctx) => ctx,
  group: (ctx) => ctx,
  screen: (ctx) => ctx,
};

export default modelEnrichmentPlugin;
